/************
 * Service Class
 * File Name ...: dashboard.service.ts
 * Generated By : ianday on 2/7/24
 * Date ........: 2/7/24
 /************/
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {retry, catchError} from 'rxjs/operators';
import {Settings} from './settings';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    public URLPath: string = Settings.getInstance().BASE_URL + 'dashboard/dashboard';

    constructor(private http: HttpClient) {
    }

    public getMetricCardDataByAgency(agId: number, startDate: string, endDate: string, prevStartDate: string, prevEndDate: string): Observable<any> {
        return this.http.get<any>(this.URLPath + '/metric_cards/' + agId + '/' + startDate + '/' + endDate + '/' +prevStartDate + '/' + prevEndDate)
            .pipe(
                retry(1)
            );
    }

    public getChartData(dataSource:string, agencyId:number): Observable<any>  {
        return this.http.get<any>(this.URLPath + '/charts/' + dataSource + '/' + agencyId)
            .pipe(
                retry(1)
            );
    }
}
